import { Facebook, Link2, Linkedin, Mail, Twitter } from "lucide-react";
import { toast } from "sonner";

export const ShareBar = ({ title, className = "" }) => {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title || "");
  const links = [
    { id: "linkedin", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`, label: "LinkedIn" },
    { id: "x", icon: Twitter, href: `https://twitter.com/intent/tweet?url=${u}&text=${t}`, label: "X" },
    { id: "facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${u}`, label: "Facebook" },
    { id: "email", icon: Mail, href: `mailto:?subject=${t}&body=${u}`, label: "Email" },
  ];
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    } catch (e) {
      toast.error("Could not copy link");
    }
  };
  const btn = "flex h-11 w-11 items-center justify-center rounded-full border border-teal/25 text-teal transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-teal hover:text-mist";
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="share-bar">
      {links.map(({ id, icon: Icon, href, label }) => (
        <a key={id} href={href} target="_blank" rel="noopener noreferrer" aria-label={`Share on ${label}`} data-testid={`share-${id}`} className={btn}>
          <Icon className="h-4 w-4" />
        </a>
      ))}
      <button onClick={copy} aria-label="Copy link" data-testid="share-copy" className={btn}>
        <Link2 className="h-4 w-4" />
      </button>
    </div>
  );
};
